export const authUtils = {
  getToken(): string | null {
    const storedAuthState = JSON.parse(localStorage.getItem('authState') || '{}') as {
      token: string | null;
    };
    return storedAuthState.token;
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};
